import { render, staticRenderFns } from "./educationTargetUsers.vue?vue&type=template&id=56627007"
import script from "./educationTargetUsers.vue?vue&type=script&lang=js"
export * from "./educationTargetUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56627007')) {
      api.createRecord('56627007', component.options)
    } else {
      api.reload('56627007', component.options)
    }
    module.hot.accept("./educationTargetUsers.vue?vue&type=template&id=56627007", function () {
      api.rerender('56627007', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/educationTargetUsers.vue"
export default component.exports